import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';

import Select from 'react-select';

import {api} from '../../actions/_request';


const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

const estados= [
    {label : 'Aprobo' , value : 1 },
    {label : 'No contesto' , value : 2 },
    {label : 'Rechazo' , value : 3 },
    {label : 'Por confirmar' , value : 4 },
];

class ClienteModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
			ticketEstado: {
               estado: '',

			},
            llamada:
            {
                id:null,
                ticket_id:0,
                usuario_id:0,
                estado_id:0,
                nota:""


            },
            action: 'save_ticket',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange     = this.handleSelectChange.bind(this);
          this.handleChangeInput = this.handleChangeInput.bind(this);
        
	}
    handleChangeInput(event)
    {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        let {llamada} = this.state;
        llamada[name] = value;

        this.setState({llamada: llamada});
  

    }

    componentWillReceiveProps(nextProps)
    {
        let {ticketEstado} = nextProps;

        let self = this;

        this.setState({
            ticketEstado : ticketEstado,
             llamada:
            {
                id : '',
                ticket_id:ticketEstado.id,
                estado_id: ticketEstado.estado,
                nota:""
            }
        });
    }

    handleSelectChange(select, name) {

        const value = select === null ? null : select.value;

        this.setState({
            ticketEstado: {
                ...this.state.ticketEstado,
                [name]: value,
            },
             llamada: {
                ...this.state.llamada,
                estado_id: value,
            },

        });
        //console.log(this.state.llamada.estado_id);

        if(name === "cliente_id") {

            this.cliente = select;
        }

    }


    handleInputChange(event) {
        let {ticketestado} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        ticketestado[name] = value;
        this.setState({
            ticketestado : ticketestado
        });
    }

	handleSubmit(evt)
	{
		evt.preventDefault();
    let {ticketEstado,llamada} = this.state;

    if(llamada.nota=="")
    {
        llamada.nota="N/A";
    }
  
         let self = this;
         this.props.save_llamada(llamada, (status) => {   });
      
		   this.props.update_estado(ticketEstado, (status) => {

               

               this.props.toggle_estado(evt,ticketEstado.estado);
               if(status){
                  swal("Bien hecho!", "El ticket fue editado con éxito!", "success");
                }else{
                  swal("Error!", "Error", "error");
                }
          });



	}

	render()
	{

        let {ticketEstado,llamada}=this.state;
		
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle_estado} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle_estado}>Notificar Cliente</ModalHeader>
                <ModalBody>{
                    <div className="row">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Estado:</Label>
                                    <Select
                                    placeholder=""
                                    type="text"
                                    name="estado"
                                    options={estados}
                                    value={parseInt(ticketEstado.estado)}
                                    onChange={ (select) => { this.handleSelectChange(select, 'estado') } }
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">Nota</label>
                                <input 
                                 type="text" 
                                 name="nota" 
                                 value={llamada.nota}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                    </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.ticket.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			<IconSave />&nbsp;Guardar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle_estado}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(ClienteModal)


// WEBPACK FOOTER //
// ./src/components/cliente/llamarCliente.js